import { useBookingStore } from "../stores/bookingStore"
import { dataGet, dataSet } from "../../Common/utils"

/**
 * Backend adapter interface for form field management
 * Allows composables to work with both Livewire (store) and REST API
 */
export function createBackendAdapter({
  getData,           // (path) => value
  getInitialData,    // (path) => value
  getErrors,         // () => errors object
  updateField,       // (path, value) => void
  addError,          // (path, message, item) => void
  clearErrors,       // () => void
}) {
  return {
    getData,
    getInitialData,
    getErrors,
    updateField,
    addError,
    clearErrors,
  }
}

/**
 * Livewire backend adapter (uses Pinia stores)
 */
export function useLivewireBackend() {
  const bookingStore = useBookingStore()

  return createBackendAdapter({
    getData: (path) => dataGet(bookingStore.data, path, ''),
    getInitialData: (path) => dataGet(bookingStore.initialBookingData?.data, path, null),
    getErrors: () => bookingStore.errors,
    updateField: (path, value) => bookingStore.updateField(path, value),
    addError: (path, message, item) => bookingStore.addError(path, message, item),
    clearErrors: () => bookingStore.clearErrors(),
  })
}

/**
 * Checkout API backend adapter (uses local reactive state)
 */
export function useCheckoutBackend(formState) {
  return createBackendAdapter({
    getData: (path) => dataGet(formState.data.value, path, ''),
    getInitialData: (path) => dataGet(formState.initialData?.value, path, null),
    getErrors: () => formState.errors.value,
    updateField: (path, value) => {
      dataSet(formState.data.value, path, value)
    },
    addError: (path, message) => {
      if (!formState.errors.value[path]) {
        formState.errors.value[path] = []
      }
      formState.errors.value[path].push(message)
    },
    clearErrors: () => {
      formState.errors.value = {}
    },
  })
}
